import { render, staticRenderFns } from "./Status.vue?vue&type=template&id=6b2b321d&scoped=true&"
import script from "./Status.vue?vue&type=script&lang=js&"
export * from "./Status.vue?vue&type=script&lang=js&"
import style0 from "./Status.vue?vue&type=style&index=0&id=6b2b321d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2b321d",
  null
  
)

export default component.exports